/** Art der Anfrage beim Anlegen eines Projekts. */
export const QUOTATION_TYPES = [
  { value: 'bidToBid', label: 'BID TO BID' },
  { value: 'firmRfq', label: 'FIRM RFQ' }
] as const;

export type QuotationType = typeof QUOTATION_TYPES[number]['value'];

export const DEFAULT_QUOTATION_TYPE: QuotationType = 'bidToBid';

export const isQuotationType = (value: unknown): value is QuotationType =>
  QUOTATION_TYPES.some((type) => type.value === value);

export const quotationTypeLabel = (value?: string | null): string =>
  QUOTATION_TYPES.find((type) => type.value === value)?.label ?? '';

export const quotationTypeItems = QUOTATION_TYPES.map((type) => ({
  text: type.label,
  value: type.value
}));
